import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { formFormatterRegex } from '../../../resources/formFormatterRegex';

export const NPI = () => {
  const { modelPrefix, onBlur } = usePropsContext();
  const { allowOnlyNumeric } = formFormatterRegex;

  return (
    <TextInput
      data-testid="npi"
      label="NPI"
      model={`${modelPrefix}.npi`}
      width="50%"
      maxLength={10}
      formatter={value => {
        return value.replace(allowOnlyNumeric, '');
      }}
      validators={{
        required: 'Please enter a valid 10-digit numeric NPI',
        minLength: {
          value: 10,
          message: 'Please enter a valid 10-digit numeric NPI',
        },
      }}
      returnUnmaskedValue
      isClearable
      onBlur={() => onBlur(`${modelPrefix}.npi`)}
    />
  );
};
